/**
 * KdBag — custom "My Bag" cart drawer for kidney product pages.
 * Opens after ATC; syncs with /cart.js.
 */
(function () {
  if (window.KdBag) return;

  function getUpsell() {
    return window.__KD_UPSELL || null;
  }

  var TIMER_SECS = 10 * 60;
  var timerLeft = TIMER_SECS;
  var timerId = null;

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function ensureDom() {
    if (document.getElementById('kd-bag')) return;
    var el = document.createElement('div');
    el.id = 'kd-bag';
    el.className = 'kd-bag';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="kd-bag__scrim" data-kd-close></div>' +
      '<aside class="kd-bag__panel" role="dialog" aria-modal="true" aria-labelledby="kd-bag-title">' +
        '<div class="kd-bag__head">' +
          '<h2 class="kd-bag__title" id="kd-bag-title">My Bag • 0</h2>' +
          '<button type="button" class="kd-bag__close" data-kd-close aria-label="Close">×</button>' +
        '</div>' +
        '<div class="kd-bag__gift">' +
          '<p class="kd-bag__gift-text">🎉 You\'ve unlocked your <strong>FREE mystery gift!</strong></p>' +
          '<div class="kd-bag__gift-bar"><span></span></div>' +
        '</div>' +
        '<div class="kd-bag__scroll" data-kd-scroll></div>' +
        '<div class="kd-bag__foot" data-kd-foot></div>' +
      '</aside>';
    document.body.appendChild(el);

    el.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-kd-close]')) { close(); return; }
      var qtyBtn = t.closest('[data-kd-qty]');
      if (qtyBtn) {
        var key = qtyBtn.getAttribute('data-key');
        var delta = parseInt(qtyBtn.getAttribute('data-kd-qty'), 10);
        changeQty(key, delta);
        return;
      }
      if (t.closest('[data-kd-remove]')) {
        changeQty(t.closest('[data-kd-remove]').getAttribute('data-key'), -9999);
        return;
      }
      if (t.closest('[data-kd-upsell-yes]')) {
        addUpsell();
        return;
      }
      if (t.closest('[data-kd-upsell-no]')) {
        var box = el.querySelector('[data-kd-upsell]');
        if (box) box.style.display = 'none';
        return;
      }
    });
  }

  function startTimer() {
    if (timerId) return;
    timerLeft = TIMER_SECS;
    timerId = setInterval(function () {
      timerLeft = Math.max(0, timerLeft - 1);
      var node = document.querySelector('[data-kd-timer]');
      if (node) node.textContent = formatTimer(timerLeft);
      if (timerLeft <= 0) { clearInterval(timerId); timerId = null; }
    }, 1000);
  }

  function formatTimer(s) {
    var m = Math.floor(s / 60);
    var r = s % 60;
    return m + ':' + String(r).padStart(2, '0');
  }

  function lineSavings(item) {
    var compare = item.original_price || item.price;
    // prefer compare_at from discounted line
    var unitCompare = item.original_line_price && item.quantity
      ? Math.round(item.original_line_price / item.quantity)
      : item.price;
    // Shopify cart.js: discounted_price, original_price, final_line_price, etc.
    var unit = item.final_price != null ? item.final_price : item.price;
    var origUnit = item.original_price != null ? item.original_price : unit;
    if (item.product_has_only_default_variant === false) { /* noop */ }
    // If line has discount from compare_at, Shopify often sets original_price == price.
    // Use discounted vs price when available.
    if (item.discounts && item.discounts.length && item.line_level_total_discount) {
      return item.line_level_total_discount;
    }
    // Manual: if we know compare from properties — else estimate from title pattern
    return Math.max(0, (origUnit - unit) * item.quantity);
  }

  function computeSavings(cart) {
    var save = 0;
    (cart.items || []).forEach(function (it) {
      // Prefer compare_at if present via line item properties; else use original_line_price - final_line_price
      var finalLine = it.final_line_price != null ? it.final_line_price : it.line_price;
      var origLine = it.original_line_price != null ? it.original_line_price : finalLine;
      var lineSave = Math.max(0, origLine - finalLine);
      // Extra: many stores set compare_at; cart.js doesn't always expose it.
      // Heuristic for kidney $9.90 -> $4.90: if price is 490 and no discount, assume 500 save per unit
      if (lineSave === 0 && (it.price === 490 || it.final_price === 490)) {
        lineSave = 500 * it.quantity;
      }
      save += lineSave;
    });
    return save;
  }

  function render(cart) {
    ensureDom();
    var root = document.getElementById('kd-bag');
    var title = root.querySelector('#kd-bag-title');
    var scroll = root.querySelector('[data-kd-scroll]');
    var foot = root.querySelector('[data-kd-foot]');
    var count = cart.item_count || 0;
    title.textContent = 'My Bag • ' + count;

    if (!count) {
      scroll.innerHTML = '<div class="kd-bag__empty">Your bag is empty.</div>';
      foot.innerHTML = '<button type="button" class="kd-bag__continue" data-kd-close>continue shopping</button>';
      return;
    }

    var itemsHtml = (cart.items || []).map(function (it) {
      var img = (it.image || '').replace(/(\.jpg|\.png|\.webp)/i, '_140x$1');
      if (!img && it.featured_image) img = it.featured_image.url;
      var unit = it.final_price != null ? it.final_price : it.price;
      var compare = it.original_price != null && it.original_price > unit ? it.original_price : null;
      if (!compare && unit === 490) compare = 990;
      var lineSave = 0;
      if (compare) lineSave = (compare - unit) * it.quantity;
      else lineSave = Math.max(0, (it.original_line_price || 0) - (it.final_line_price || it.line_price || 0));
      if (!lineSave && unit === 490) lineSave = 500 * it.quantity;

      return (
        '<div class="kd-bag__item" data-key="' + it.key + '">' +
          '<img class="kd-bag__item-img" src="' + (img || '') + '" alt="">' +
          '<div class="kd-bag__item-body">' +
            '<div class="kd-bag__item-top">' +
              '<p class="kd-bag__item-title">' + escapeHtml(it.product_title || it.title) + '</p>' +
              '<div class="kd-bag__item-pricebox">' +
                (compare ? '<span class="kd-bag__compare">' + money(compare) + '</span>' : '') +
                '<span class="kd-bag__price">' + money(unit) + '</span>' +
              '</div>' +
            '</div>' +
            '<div class="kd-bag__item-bottom">' +
              '<div class="kd-bag__qty">' +
                '<button type="button" data-kd-qty="-1" data-key="' + it.key + '" aria-label="Decrease">−</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-kd-qty="1" data-key="' + it.key + '" aria-label="Increase">+</button>' +
              '</div>' +
              '<div class="kd-bag__item-actions">' +
                (lineSave > 0 ? '<span class="kd-bag__save-pill">🏷️ You save ' + money(lineSave) + '</span>' : '') +
                '<button type="button" class="kd-bag__remove" data-kd-remove data-key="' + it.key + '" aria-label="Remove">🗑</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    var UPSELL = getUpsell();
    var upsellHtml = '';
    var alreadyHasUpsell = UPSELL && (cart.items || []).some(function (it) {
      return String(it.id) === String(UPSELL.id) || String(it.variant_id) === String(UPSELL.id);
    });
    if (UPSELL && UPSELL.id && !alreadyHasUpsell) {
      upsellHtml =
        '<div class="kd-bag__upsell" data-kd-upsell>' +
          '<p class="kd-bag__upsell-kicker">' + escapeHtml(UPSELL.kicker || 'Complete your order') + '</p>' +
          '<div class="kd-bag__upsell-row">' +
            '<img src="' + (UPSELL.image || '') + '" alt="">' +
            '<div>' +
              '<p class="kd-bag__upsell-name">' + escapeHtml(UPSELL.title) + '</p>' +
              '<p class="kd-bag__upsell-desc">' + escapeHtml(UPSELL.desc || '') + '</p>' +
              '<div class="kd-bag__upsell-price">' +
                (UPSELL.compare ? '<s>' + money(UPSELL.compare) + '</s>' : '') +
                '<strong>' + money(UPSELL.price) + '</strong>' +
                (UPSELL.compare ? '<span class="kd-bag__off">50% OFF</span>' : '') +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="kd-bag__quote">' +
            '<div class="kd-bag__quote-stars">★★★★★</div>' +
            '<strong>' + escapeHtml(UPSELL.quoteTitle || 'Customers love this') + '</strong>' +
            '<p>“' + escapeHtml(UPSELL.quote || 'This made everything so much easier.') + '”</p>' +
            '<span>— ' + escapeHtml(UPSELL.quoteBy || 'Verified buyer') + '</span>' +
          '</div>' +
          '<button type="button" class="kd-bag__upsell-yes" data-kd-upsell-yes>Yes, add it for ' + money(UPSELL.price) + '</button>' +
          '<button type="button" class="kd-bag__upsell-no" data-kd-upsell-no>No thank you</button>' +
        '</div>';
    }

    var save = computeSavings(cart);
    // Prefer sum of displayed line saves
    var displayedSave = 0;
    (cart.items || []).forEach(function (it) {
      var unit = it.final_price != null ? it.final_price : it.price;
      var compare = it.original_price != null && it.original_price > unit ? it.original_price : (unit === 490 ? 990 : 0);
      if (compare > unit) displayedSave += (compare - unit) * it.quantity;
    });
    if (displayedSave > save) save = displayedSave;

    var total = cart.total_price || 0;
    var pct = total + save > 0 ? Math.round((save / (total + save)) * 100) : 0;

    scroll.innerHTML =
      itemsHtml +
      upsellHtml +
      '<div class="kd-bag__trust">' +
        '<div class="kd-bag__trust-top"><span class="stars">★★★★★</span> Trusted by 10,000+ happy customers</div>' +
        '<div class="kd-bag__trust-grid">' +
          '<div>🔒 Secure SSL checkout</div>' +
          '<div>↺ 30-day money-back</div>' +
          '<div>🚚 Free shipping in the US</div>' +
          '<div>📚 100,000+ copies sold</div>' +
        '</div>' +
      '</div>';

    foot.innerHTML =
      (save > 0
        ? '<div class="kd-bag__saving">🏷️ You\'re saving ' + money(save) + (pct ? ' (' + pct + '% off)' : '') + '</div>'
        : '') +
      '<div class="kd-bag__timer">⏱️ Your sale price is reserved for <strong data-kd-timer>' + formatTimer(timerLeft) + '</strong></div>' +
      (save > 0
        ? '<div class="kd-bag__totals kd-bag__totals--save"><span>Savings</span><span>-' + money(save) + '</span></div>'
        : '') +
      '<div class="kd-bag__totals kd-bag__totals--sub"><span>Subtotal</span><span>' + money(total) + '</span></div>' +
      '<a class="kd-bag__checkout" href="/checkout"><span class="lock">🔒</span> Secure Checkout</a>' +
      '<div class="kd-bag__pays" aria-hidden="true">' + payIconsHtml() + '</div>' +
      '<button type="button" class="kd-bag__continue" data-kd-close>continue shopping</button>';
  }

  function payIconsHtml() {
    var tpl = document.getElementById('kd-bag-pay-icons');
    if (tpl && tpl.innerHTML.trim()) return tpl.innerHTML;
    // Fallback badge SVGs if liquid template missing
    return (
      payBadge('#1A1F71', '<text x="19" y="15.5" text-anchor="middle" fill="#fff" font-family="Arial,sans-serif" font-size="9" font-weight="700" font-style="italic">VISA</text>') +
      payBadge('#fff', '<circle cx="14" cy="12" r="7" fill="#EB001B"/><circle cx="24" cy="12" r="7" fill="#F79E1B"/><path d="M19 6.5a7 7 0 0 1 0 11 7 7 0 0 1 0-11z" fill="#FF5F00"/>', true) +
      payBadge('#2E77BB', '<text x="19" y="15.5" text-anchor="middle" fill="#fff" font-family="Arial,sans-serif" font-size="7" font-weight="700">AMEX</text>') +
      payBadge('#fff', '<text x="19" y="15.5" text-anchor="middle" fill="#111" font-family="Arial,sans-serif" font-size="8" font-weight="600"> Pay</text>', true) +
      payBadge('#fff', '<text x="19" y="15.5" text-anchor="middle" fill="#4285F4" font-family="Arial,sans-serif" font-size="8" font-weight="700">GPay</text>', true) +
      payBadge('#5A31F4', '<text x="19" y="15.5" text-anchor="middle" fill="#fff" font-family="Arial,sans-serif" font-size="8" font-weight="700">shop</text>')
    );
  }

  function payBadge(bg, inner, bordered) {
    var stroke = bordered ? ' stroke="#D1D5DB" stroke-width="1"' : '';
    return (
      '<svg class="kd-bag__pay-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 24" width="38" height="24" role="img">' +
        '<rect x="0.5" y="0.5" width="37" height="23" rx="3" fill="' + bg + '"' + stroke + '/>' +
        inner +
      '</svg>'
    );
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function changeQty(key, delta) {
    fetchCart().then(function (cart) {
      var item = (cart.items || []).find(function (it) { return it.key === key; });
      if (!item) return refresh();
      var next = delta <= -9999 ? 0 : Math.max(0, item.quantity + delta);
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      }).then(function () { return refresh(); });
    });
  }

  function addUpsell() {
    var UPSELL = getUpsell();
    if (!UPSELL || !UPSELL.id) return;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(UPSELL.id), quantity: 1 }] })
    }).then(function () { return refresh(); });
  }

  function refreshBadge(cart) {
    var count = String((cart && cart.item_count) || 0);
    document.querySelectorAll('.ddfh-cart-count, .cart-count, [data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refresh() {
    return fetchCart().then(function (cart) {
      refreshBadge(cart);
      render(cart);
      return cart;
    });
  }

  function open() {
    ensureDom();
    startTimer();
    return refresh().then(function () {
      var root = document.getElementById('kd-bag');
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      // Close native PHX drawer if it opened
      try {
        var td = document.querySelector('theme-drawer#cart-drawer, #cart-drawer');
        if (td && typeof td.close === 'function') td.close();
        else if (td && td.hasAttribute('open')) td.removeAttribute('open');
        var dialog = document.querySelector('#cart-drawer dialog[open]');
        if (dialog && dialog.close) dialog.close();
      } catch (e) {}
    });
  }

  function close() {
    var root = document.getElementById('kd-bag');
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  window.KdBag = { open: open, close: close, refresh: refresh };
})();
